import { registerDe } from '../i18n/index.js';

registerDe({
  'Attach transcript': 'Transkript anhängen',
  'Upload transcript': 'Transkript hochladen',
  'Uploading…': 'Wird hochgeladen…',
  'kB': 'kB',
  'A transcript is a .txt, .vtt or .md file. That one is not.':
    'Ein Transkript ist eine .txt-, .vtt- oder .md-Datei. Diese ist keine.',
  'That file is larger than 5 MB. Nothing was sent.':
    'Diese Datei ist grösser als 5 MB. Es wurde nichts gesendet.',
  'Give the date the meeting was held before attaching its transcript.':
    'Geben Sie das Datum der Sitzung an, bevor Sie ihr Transkript anhängen.',
  'The transcript could not be uploaded.': 'Das Transkript konnte nicht hochgeladen werden.',
  'Uploading logs the meeting with the transcript as its body — that is the save. A reading then proposes the commitments and the facts it finds; nothing reaches the record without your click.':
    'Das Hochladen erfasst die Sitzung mit dem Transkript als Inhalt — das ist das Speichern. Eine Lesung schlägt danach die gefundenen Zusagen und Fakten vor; ohne Ihren Klick gelangt nichts in den Datensatz.',
  'Logged as': 'Erfasst als',
  'reading it as run': 'gelesen als Lauf',
  'what it finds arrives in Review as proposals.': 'was er findet, erscheint in der Prüfung als Vorschläge.',
  'the transcript is on the record, but no reading started:':
    'das Transkript ist im Datensatz, aber es wurde keine Lesung gestartet:',
  'the model endpoint did not answer.': 'der Modell-Endpunkt hat nicht geantwortet.',
}, 'TranscriptUpload');
